import { render, staticRenderFns } from "./F12.vue?vue&type=template&id=a1c0d7ea&scoped=true"
import script from "./F12.vue?vue&type=script&lang=js"
export * from "./F12.vue?vue&type=script&lang=js"
import style0 from "./F12.vue?vue&type=style&index=0&id=a1c0d7ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1c0d7ea",
  null
  
)

export default component.exports